import Link from 'next/link'
import React from 'react'

function DiscoverHeroSection() {
   return (
      <section className="portfolio-template-subPage section_secondary_bg first-section pb-4">
         <div className="container text-center">
            <div className="portfolio_breadCrumb mb-4">
               <Link href="/" className="d-inline">
                  Home
               </Link>
               <img
                  className="mx-2"
                  height="10"
                  width="10"
                  src="/assets/svg/two-right-icon.svg"
               />
               <span> About our Company</span>
            </div>
            <h1 className="section_heading_title tech_title mb-3">
               We’ve been coding chaos into order since 2013.
            </h1>
            <p className="section_desc">
               Since 2013, we’ve been wrangling chaos into code, transforming
               digital mayhem into sleek, needle-moving order. It all kicked off
               with a ragtag crew of dreamers—powered by late-night pizza,
               bottomless coffee, and an unrelenting obsession to outsmart
               clunky tech. What started as gritty prototypes hacked together in
               the wee hours has evolved into a decade-plus legacy of building
               software and apps that don’t just function—they disrupt, they
               dazzle, they deliver. We’re the ones who take a wild 'what if,'
               wrestle it into reality, and crank it up to a resounding 'hell
               yeah.' Over the years, we’ve gone from underdog tinkerers to
               architects of innovation, always chasing the next big spark
            </p>
            <div className="position-relative mt-5">
               <Link href="/portfolio" className="btn bez-fill-btn">
                  View portfolio
                  <svg
                     width="25"
                     height="25"
                     viewBox="0 0 25 25"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M14.2011 19.6006C14.0025 19.6018 13.808 19.5437 13.6425 19.4339C13.477 19.3241 13.3479 19.1675 13.2718 18.9841C13.1956 18.8007 13.1758 18.5987 13.2148 18.4039C13.2539 18.2092 13.3501 18.0305 13.4911 17.8906L18.7911 12.6006L13.4911 7.31061C13.3273 7.11931 13.2417 6.87324 13.2514 6.62156C13.2611 6.36988 13.3655 6.13114 13.5436 5.95305C13.7217 5.77496 13.9604 5.67062 14.2121 5.6609C14.4638 5.65118 14.7098 5.73679 14.9011 5.90061L20.9011 11.9006C21.0874 12.088 21.1919 12.3414 21.1919 12.6056C21.1919 12.8698 21.0874 13.1233 20.9011 13.3106L14.9011 19.3106C14.7149 19.4954 14.4635 19.5995 14.2011 19.6006Z"
                        fill="#F4F2F0"
                     />
                     <path
                        d="M6.19527 19.6017C5.99664 19.6029 5.80218 19.5449 5.63666 19.4351C5.47114 19.3253 5.34206 19.1687 5.2659 18.9852C5.18973 18.8018 5.16992 18.5998 5.20899 18.4051C5.24806 18.2103 5.34424 18.0316 5.48527 17.8918L10.7853 12.6017L5.48527 7.31175C5.29697 7.12344 5.19118 6.86805 5.19118 6.60175C5.19118 6.33545 5.29697 6.08005 5.48527 5.89175C5.67357 5.70344 5.92897 5.59766 6.19527 5.59766C6.46157 5.59766 6.71697 5.70344 6.90527 5.89175L12.9053 11.8917C13.0915 12.0791 13.1961 12.3326 13.1961 12.5967C13.1961 12.8609 13.0915 13.1144 12.9053 13.3017L6.90527 19.3018C6.81265 19.3962 6.70221 19.4714 6.58033 19.5229C6.45846 19.5744 6.32758 19.6012 6.19527 19.6017Z"
                        fill="#F4F2F0"
                     />
                  </svg>
               </Link>
            </div>
         </div>
      </section>
   )
}

export default DiscoverHeroSection
